import { useEffect, useRef } from "react";
import { useAuthStore } from "@/store/authStore";
import { AppRoutes } from "./routes/AppRoutes";
import { refreshBuilderAccountStatus } from "@/utils/accountStatus";

export default function App() {
  const initAuth = useAuthStore((s) => s.initAuth);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const loading = useAuthStore((s) => s.loading);
  const hasRefreshedAccountStatus = useRef(false);

  useEffect(() => {
    initAuth();
  }, [initAuth]);

  useEffect(() => {
    if (!loading && isAuthenticated && !hasRefreshedAccountStatus.current) {
      hasRefreshedAccountStatus.current = true;
      refreshBuilderAccountStatus();
    }

    if (!isAuthenticated) {
      hasRefreshedAccountStatus.current = false;
    }
  }, [isAuthenticated, loading]);

  return <AppRoutes />;
}
